import React from 'react';
import PropTypes from 'prop-types';

// Components
import withLocale from '../withLocale/withLocale';

export function DefaultButtonComponent({ default: defaulted, disabled, locale, onChange }) {
  if (!defaulted) {
    return (
      <button type="button" className="btn btn-link" disabled={disabled} onClick={onChange}>
        {locale['common.makeDefault']}
      </button>
    );
  }
  return (
    <button type="button" className="btn btn-link" disabled>
      {locale['common.default']}
    </button>
  );
}

DefaultButtonComponent.propTypes = {
  default: PropTypes.bool,
  disabled: PropTypes.bool,
  locale: PropTypes.objectOf(PropTypes.string),
  onChange: PropTypes.func
};

DefaultButtonComponent.defaultProps = {
  default: false,
  disabled: false,
  locale: {},
  onChange() {}
};

export default withLocale(DefaultButtonComponent);
